import React from "react";
import { ProductConsumer } from "../../context";

export default function TotalPrice() {
  return (
    <ProductConsumer>
      {(value) => {
        const { cartTotal } = value;
        return (
          <div className="row mt-5 mt-lg-0 text-capitalize text-center align.items-center">
            <div className="col-10 mx-4 text-left col-lg-2 pb-2">
              <h6 className="font-weight-bold">Total</h6>
            </div>
            <div className="col-10 mx-auto col-lg-2 pb-2">
              <p></p>
            </div>
            <div className="col-10 mx-auto col-lg-2 my-2 my-lg-0"></div>
            <div className="col-10 mx-auto col-lg-2 ">
              <strong className="text-muted">{cartTotal} kr</strong>
            </div>
          </div>
        );
      }}
    </ProductConsumer>
  );
}
